webpackJsonp([67296944263128],{

/***/ 1386:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Why React? A Deeper Look into Facebook’s Hit Framework","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/why-react-a-deeper-look-into-facebooks-hit-framework","createdAt":"2017-08-02T22:19:36.149Z","blogAuthor":{"fields":{"name":"Mark Palfreeman","slug":"blog/author/mark-palfreeman"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/4rm4ghjJgcMyk8kI0OQgcy/85bce8e682d429cd720537c6f1c0e677/blog-post-blog-why-react-a-deeper-look-into-facebooks-hit-framework.png"}}}}}]},"authorJson":{"name":"Mark Palfreeman","slug":"blog/author/mark-palfreeman","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/mark-palfreeman"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-mark-palfreeman-d5f5adfccc72588ae7dd.js